import State from '@/state/State';
import { isRecognitionOnlyClaims } from '@/utils/scopedAdminGate';

export const isFlexPayLike = (claims = null) => {
  if (claims == null) {
    claims = State.state.claims;
  }
  return claims?.a || claims?.m || claims?.is;
};

// NB: Onboarding clients are gated to the /onboarding placeholder regardless of
// the company's partner_state. The intent of ROLE_ONBOARDING_CLIENT is "this
// person was seeded during onboarding and must NEVER be auto-upgraded to
// portal admin access" — even after the company is promoted to LIVE, they
// must contact support to be re-permissioned. The Onboarding page itself
// surfaces a different message once the company is no longer in ONBOARDING.
export const isOnboardingClient = (claims = null) => {
  if (claims == null) {
    claims = State.state.claims;
  }
  return Boolean(claims?.oc);
};

// Scoped (limited) admins the portal knows how to confine — currently only
// the recognition-only admin. Deliberately fail-closed: a future scope (e.g.
// payroll) is NOT admitted until its confinement gate ships alongside it.
export const isScopedAdmin = (claims = null) => {
  if (claims == null) {
    claims = State.state.claims;
  }
  return isRecognitionOnlyClaims(claims);
};
